/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import moment from 'moment';
import React, { useEffect, useState, useContext } from 'react';
import AnimatedList from '../../../../../components/Animation/AnimatedList';
import AnimatedButton from '../../../../../components/Animation/AnimatedButton';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FormattedNumber } from '../../../../../CommonMethods/FormattedNumber';
import { CognitoData } from '../../../../../CommonMethods/CognitoData';
import GlobalContext from '../../../../../components/Context/GloablContext';
import FormatDateString from '../../../../../CommonMethods/FromatDateString';
import { CDN } from '../../../../../config';
const TableBody = ({
    lastIndex,
    tableData, 
    indexNum, 
    searchParams,
    setSearchParams,
    selectedIndex, 
    setSelectedIndex, 
    selectedRef,
}) => {
    /**
     * This function sets the confirmation state to activate or deactivate an item in a table.
     */
    const [userCognitoEmail, setUserCognitoEmail] = useState('');
    const [userType, setUserType] = useState('');
    const location=useNavigate();
    const {isInactiveBranch} = useContext(GlobalContext);
    const navigate = useNavigate();

    /**
     * The function `handelActionButton` sets the selected index to the provided index number.
     */
    
    const handelActionButton = async(indexNum) =>{
        setSelectedIndex(indexNum)
       
    }

    /**
    * The function `getCurrentUserData` retrieves the current user's email from Cognito data and sets
    * it as the user's Cognito email.
    */
    const getCurrentUserData = async() => {
        const data = await CognitoData()
        setUserCognitoEmail(data.accessToken.payload.username)
        setUserType(data.idToken.payload["custom:user_type"])
    }

    const handleNavigateToIssueInventory = (data) => {
        const params = new URLSearchParams({
            student_name: data?.full_name || "",
            student_id: data?.student_id || "",
            student_uuid: data?._id || "",
            academic_year_name: data?.academic_year?.name || "",
            academic_year_id: data?.academic_year?.academic_year_id || "",
            academic_start: data?.academic_year.start_date,
            academic_end: data?.academic_year.end_date,
            class: data?.classes?.class_name || "",
            class_id: data?.classes?.class_id || "",
            sections: data?.sections?.section_name || "",
            section_id: data?.sections?.section_id || "",
            doa: data?.date_of_admission || "",
            isFromDirectory: true,
            redirect_url: `/student-master/directory?${searchParams.toString()}`
        });
        
      
        navigate(`/student-master/invoice-list/issue-inventory?${params.toString()}`);
    };
      
   
   
    /* The `useEffect` hook is used to perform side effects in a functional component. In this case, it
    is used to call the `getCurrentUserData` function when the component mounts. The
    `getCurrentUserData` function retrieves the current user's email from Cognito data and sets it as
    the user's Cognito email. The empty array `[]` as the second argument to `useEffect` ensures that
    the effect is only run once, when the component mounts. */
    useEffect(() => {
        getCurrentUserData()
    }, []);

    const handleEditClick = (id) => {
        navigate(`/student-master/directory/edit-student/${id}?${searchParams.toString()}`);
    };

    const handleCollectFeeClick = (id) => {
        navigate(`/student-master/collect-fee/collect-fee-invoice/${tableData?._id}`);
    };

    /**
     * The function `handleStatus` takes a key as input and returns the corresponding value from an
     * object based on the status of a table data.
     * @returns The value of the specified key from the `val` object is being returned.
     */
    const handleStatus = (key) => {
        let val = {}
        switch (tableData?.status) {
        case "active":
            val = {status : "Active", img: "successDot.svg", color : "bg-[#C5FFD5]", icon:''}
            break;
        case "transferred":
            val = {status : "Transferred", img: "bluedot.svg", color : "bg-[#C2DCEF]", icon: "transferred"}
            break;
        case "terminated":
            val = {status :"Terminated", img: "redDot.svg", color : "bg-[#FFD6D3]", icon: "terminated"}
            break;
        
        default:
            break;
        }
        return val[key]
    }

    const openStudentStatement = (id) =>{
        location(`/student-master/directory/${tableData._id}?${searchParams.toString()}&tab_name=Student Statement`)
    }

    return (
        <>
            <tr   
                className={`${(tableData.status)? '' : 'inactive'} cursor-pointer applyShadow`}
                key={indexNum}
                title={`View Student`}
                onClick={(e)=>{
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        location(`/student-master/directory/${tableData._id}?${searchParams.toString()}`)
                    }
                }}>
                
                <td>
                    <div data-testid="student-id" class="flex w-[100%] mb-[10px] mt-1 pb-[6px] border-b justify-between" style={{'border-color':'#f0f0f0'}}>
                        <div class=" flex hover:underline" style={{ 'color': '#0a6dad' }}>
                            <div class="font-semibold">[{tableData.student_id || "-"}] {tableData?.full_name || "-"}</div>
                        </div>
                        {tableData?.status === 'active' && !isInactiveBranch ?
                            <>
                                <div class='flex'>
                                    <button
                                        class="flex prevent-click mr-2 hover:underline"
                                        data-tooltip-target="panuploadInfo"
                                        data-tooltip-trigger="hover"
                                        data-tooltip-placement="top"
                                        title="Edit Student"
                                        type="button"
                                        style={{ 'color': '#106eb4' }}
                                        onClick={() => openStudentStatement(tableData._id)}>
                                        Total Outstanding Fee: <p alt="icon" class="ml-1 mr-[2px]"> <spam id={`total-outstanding-fee_${tableData._id}`}>{Number(tableData?.total_remaining_amount).toFixed(2)}</spam></p>
                                    </button>
                                    <button
                                        class="prevent-click mr-2"
                                        data-tooltip-target="panuploadInfo"
                                        data-tooltip-trigger="hover"
                                        data-tooltip-placement="top"
                                        title="Edit Student"
                                        type="button"
                                        disabled=""
                                        onClick={() => handleEditClick(tableData._id)}>
                                        <img loading="lazy" decoding="async" src="/images/student-edit-icon.svg" alt="img" class="w-6 h-6  prevent-click hover:bg-[#eef7fe]" />
                                    </button>
                                    <button
                                        class="prevent-click mr-2"
                                        data-tooltip-target="panuploadInfo"
                                        data-tooltip-trigger="hover"
                                        data-tooltip-placement="top"
                                        title="Issue Invoice"
                                        type="button"
                                        disabled=""
                                        onClick={() => handleNavigateToIssueInventory(tableData)}>
                                        <img loading="lazy" decoding="async" src="/images/invoice_icon.svg" alt="img" class="w-6 h-6  prevent-click hover:bg-[#eef7fe]" />
                                    </button>
                                    <button
                                        class="prevent-click"
                                        data-tooltip-target="panuploadInfo"
                                        data-tooltip-trigger="hover"
                                        data-tooltip-placement="top"
                                        title={Number(tableData?.total_remaining_amount) > 0 ? "Collect Fee" : "No Outstanding Fee"}
                                        type="button"
                                        disabled={Number(tableData?.total_remaining_amount) === 0}
                                        onClick={() => handleCollectFeeClick(tableData._id)}>
                                        <img loading="lazy" decoding="async" src="/images/collect-fee-icon.svg" alt="img" class="w-6 h-6  prevent-click hover:bg-[#eef7fe]" />
                                    </button>
                                </div>
                            </>: 
                            <div className='flex justify-start'>
                                <div className={`w-fit rounded ${handleStatus("color")} flex items-center justify-center py-0.5 px-2.5`}>
                                    <img loading="lazy" decoding="async" src={`/images/${handleStatus("img")}`} alt="icon" />
                                    <span class="text-f7 font-normal text-[#031624] pl-1">{handleStatus("status")}</span>
                                </div>
                            </div>}
                    </div>
                    <div class="flex mb-1">
                        <div class="flex items-center w-[10%]">
                            <img src={tableData?.image_url !== "" ? `${CDN}${tableData?.image_url}`:"/images/photo_uploaded.svg"} alt="img" class="w-[96px] h-[96px] rounded border border-[#e7e7e7]"/>
                        </div>
                        <div class="flex items-center w-[90%]">
                            <div class=" w-[30%] ml-3">
                                <div class="flex mb-2">{tableData?.gender || 'Female'} / {FormatDateString(tableData?.date_of_birth) || "-"}</div>
                                <div class="flex mb-2">{tableData?.email_address || "-"}</div>
                                <div class="flex mb-2">{FormattedNumber(tableData?.mobile_number) || "-"}</div>
                            </div>
                            <div class=" w-[25%] ml-5">
                                {tableData?.academic_year?.name && <><div data-testid="academic_year" class="flex mb-2">{tableData?.academic_year?.name || "-"}</div>
                                    <div data-testid="class_name" class="flex mb-2">{tableData?.classes?.class_name || "-"}, {tableData?.sections?.section_name || "-"}</div>
                                    <div class="flex mb-2">&nbsp;</div></>}
                                {!tableData?.academic_year?.name && <><div data-testid="no_academic_year" class="flex">{'No AY Details'}</div>
                                    <div class="flex mb-2">&nbsp;</div><div class="flex mb-2">&nbsp;</div></>}  
                                
                            </div>
                            <div class="w-[40%] ml-5">
                                <div class="flex">
                                    <span class='w-[28%] mb-2' style={{ 'color': '#666' }}>Parent Name</span>
                                    <span class="ml-2 more-lines">{tableData?.is_father_details ? tableData?.father_details?.first_name : tableData?.is_mother_details && tableData?.mother_details?.first_name || "-"}</span>
                                </div>
                                <div class="flex" title='Date of Admission'>
                                    <span class='w-[28%] mb-2' style={{ 'color': '#666' }}>DOA</span>
                                    <span class="ml-2">{FormatDateString(tableData?.date_of_admission) || "-"}</span>
                                </div>
                                <div class="flex" title='Registration Number'>
                                    <span class='w-[28%] mb-2' style={{ 'color': '#666' }}>Reg. No</span>
                                    <span class="ml-2">{tableData?.registration_number === "" || tableData?.registration_number === undefined ? "--" : tableData?.registration_number || "-"}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            <tr aria-colspan="7" class="relative h-[0.7rem] z-[-10]"></tr>
        </>
        
    );
}

export default TableBody;
